module.exports = __webpack_public_path__ + "static/media/LogoSabor2.40e3f71f.png";